var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { sendAjaxRequest, sendGETRequest } from "../API";
import { getContentURL } from "../ContentAPI";
import { ChannelCard } from "../components/ChannelCard";
import { PostCard } from "../components/PostCard";
import { authUrl } from "../util/UrlUtils";
import { loadChannelDataFromURL, loadChannelData, } from "../util/DataUtils";
const PUBLIC_HOME_DISCOVERY_FILENAME = "/d/frontPageDiscovery.json?cb=";
const LOGPREFIX = "DiscoveryStore: ";
export const discoveryPostEntryToReactElement = (entry, cacheBusterStore, auth, navigate, logger, onLoadError) => {
    const postKey = entry.channelOwnerId + ":" + entry.channelId + ":" + entry.postId;
    return (_jsx(PostCard, { keyStr: "postKeyCard." + postKey, basePath: getContentURL(), enableEditButtons: false, expandPostContent: false, channelOwnerId: entry.channelOwnerId, channelId: entry.channelId, postId: entry.postId, postJson: authUrl("u/" +
            entry.channelOwnerId +
            "/" +
            entry.channelId +
            "/" +
            entry.postId +
            (entry.postId.endsWith(".json") ? "" : ".json"), cacheBusterStore, auth), lazyLoad: true, onClick: () => {
            logger.log(LOGPREFIX +
                "post.onClick: channelId " +
                entry.channelId +
                " postId " +
                entry.postId);
            navigate("/PostView?channelOwnerId=" +
                entry.channelOwnerId +
                "&channelId=" +
                entry.channelId +
                "&postId=" +
                entry.postId);
        }, onLoadError: onLoadError }, "postKeyCard." + postKey));
};
export const loadFrontPageDiscovery = (callbacks, channelsOnly, navigate, cacheBusterStore, logger, auth, onPostLoadError) => __awaiter(void 0, void 0, void 0, function* () {
    logger.log(LOGPREFIX + "loadFrontPageDiscovery");
    const postEntries = [];
    const elements = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const deDupePostIds = {};
    const sortAndInsertEntries = () => {
        // Sort by timestamp
        postEntries.sort((a, b) => a.postId.localeCompare(b.postId));
        postEntries.forEach((entry) => {
            let postId = entry.postId;
            if (postId.endsWith(".json")) {
                postId = postId.substring(0, postId.length - 5);
            }
            entry.postId = postId;
            if (deDupePostIds[postId]) {
                return;
            }
            deDupePostIds[postId] = 1;
            elements.push(discoveryPostEntryToReactElement(entry, cacheBusterStore, auth, navigate, logger, onPostLoadError));
        });
    };
    const processChannels = (topChannelsAndPosts) => {
        logger.log(LOGPREFIX + "processChannels");
        // Validate channels before adding them
        const channelsToValidate = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        topChannelsAndPosts.topChannels.forEach((chanKey) => {
            const chanKeyParts = chanKey.split(":");
            const channelOwnerId = chanKeyParts[0];
            const channelId = chanKeyParts[1];
            channelsToValidate.push({ chanKey, channelOwnerId, channelId });
        });
        logger.log(LOGPREFIX + "Validating discovery channels: " + channelsToValidate.length);
        if (channelsToValidate.length === 0) {
            logger.log(LOGPREFIX +
                "processChannels - no channels to validate, invoking okCallback");
            callbacks.okCallback(elements);
            return;
        }
        // Use a counter to track when all validations complete
        let pendingValidations = channelsToValidate.length;
        // Validate each channel
        channelsToValidate.forEach((channel) => {
            const validationCallbacks = {
                okCallback: () => {
                    // Channel exists - add to elements
                    const channelJson = "u/" +
                        channel.channelOwnerId +
                        "/" +
                        channel.channelId +
                        "/channelData.json";
                    elements.push(_jsx(ChannelCard, { keyStr: "chanKeyCard." + channel.chanKey, basePath: getContentURL(), enableEditButtons: false, channelJson: authUrl(channelJson, cacheBusterStore, auth), maxResolution: true, maxMediaWidth: window.innerWidth, maxMediaHeight: window.innerHeight }, "chanKeyCard." + channel.chanKey));
                    logger.log(LOGPREFIX + `Discovery channel ${channel.channelId} is valid`);
                    // Decrement counter and check if all validations are complete
                    pendingValidations--;
                    if (pendingValidations === 0) {
                        logger.log(LOGPREFIX +
                            "processChannels - all validations complete, invoking okCallback with " +
                            elements.length +
                            " valid channels");
                        callbacks.okCallback(elements);
                    }
                },
                errorCallback: (clientDetailCode, errorMessage) => {
                    logger.log(LOGPREFIX +
                        `Discovery channel ${channel.channelId} is invalid/deleted: ${errorMessage} (${clientDetailCode})`);
                    // Decrement counter and check if all validations are complete
                    pendingValidations--;
                    if (pendingValidations === 0) {
                        logger.log(LOGPREFIX +
                            "processChannels - all validations complete, invoking okCallback with " +
                            elements.length +
                            " valid channels");
                        callbacks.okCallback(elements);
                    }
                },
            };
            // Use loadChannelData for validation
            // Create a minimal auth object if auth is undefined
            const authForValidation = auth || {
                isSignedIn: () => false,
                bearer: undefined,
                sequence: undefined,
                setBearerAndSequence: () => { },
                userId: undefined,
                displayName: undefined,
            };
            loadChannelData("u", channel.channelOwnerId, channel.channelId, "channelData", "json", validationCallbacks, authForValidation, cacheBusterStore, logger);
        });
    };
    const startTime = new Date().getTime();
    const topPostsChannelsCallback = (ok, status, message) => {
        logger.log(LOGPREFIX +
            "topPostsChannelsCallback: ok = " +
            ok +
            ", status = " +
            status +
            ", message = " +
            message);
        // const deDupePostIds: any = {};
        if (!ok || status < 200 || status > 299) {
            logger.error(LOGPREFIX +
                "topPostsChannelsCallback - status = " +
                status +
                ", message = " +
                message);
            const errorMessage = message
                ? message
                : "Request Failed - Status = " + status;
            callbacks.errorCallback(errorMessage);
            return;
        }
        try {
            const endTime = new Date().getTime();
            logger.log("Timing: topPosts " + (endTime - startTime) + " millis");
            const topChannelsAndPosts = JSON.parse(message);
            if (!channelsOnly) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                topChannelsAndPosts.topPosts.forEach((postKey) => {
                    const postKeyParts = postKey.split(":");
                    const channelOwnerId = postKeyParts[0];
                    const channelId = postKeyParts[1];
                    //            const postOwnerId = postKeyParts[2];
                    const postId = postKeyParts[3];
                    const postEntry = {
                        channelOwnerId,
                        channelId,
                        postId,
                    };
                    postEntries.push(postEntry);
                });
                if (auth && auth.isSignedIn()) {
                    const startTime = new Date().getTime();
                    loadLatestPersonalized({
                        okCallback: function (entries) {
                            const endTime = new Date().getTime();
                            logger.log("Timing: loadLatestPersonalized " +
                                (endTime - startTime) +
                                " millis");
                            entries.forEach((entry) => {
                                postEntries.push(entry);
                            });
                            sortAndInsertEntries();
                            processChannels(topChannelsAndPosts);
                            return;
                        },
                        errorCallback: function (message) {
                            logger.error(LOGPREFIX +
                                "topPostsChannelsCallback - errorCallback message = " +
                                message);
                            let errorMessage = message;
                            if (!errorMessage) {
                                errorMessage = "Unknown Error";
                            }
                            callbacks.errorCallback(errorMessage);
                            return;
                        },
                    }, navigate, cacheBusterStore, logger, auth, deDupePostIds);
                }
                else {
                    // Not signed in
                    logger.log(LOGPREFIX + "user is NOT signed in");
                    sortAndInsertEntries();
                    processChannels(topChannelsAndPosts);
                    return;
                }
            }
            else {
                // Channels only
                processChannels(topChannelsAndPosts);
                return;
            }
        }
        catch (err) {
            logger.error(LOGPREFIX + "topPostsChannelsCallback - error = " + err);
            callbacks.errorCallback(err.message);
            return;
        }
    };
    const url = window.location.href.includes("localhost:8080")
        ? PUBLIC_HOME_DISCOVERY_FILENAME + cacheBusterStore.getCacheBuster()
        : getContentURL() +
            PUBLIC_HOME_DISCOVERY_FILENAME +
            cacheBusterStore.getCacheBuster();
    sendGETRequest(topPostsChannelsCallback, url, cacheBusterStore, logger);
});
export const loadTopFrontPageImage = (callbacks, cacheBusterStore, logger, auth) => {
    logger.log(LOGPREFIX + "loadTopFrontPageImage: Loading...");
    const apiCallback = (ok, status, message, cacheBusterStore) => {
        logger.log(LOGPREFIX +
            "loadTopFrontPageImage: ok = " +
            ok +
            ", status = " +
            status +
            ", message = " +
            message);
        if (ok && status >= 200 && status < 300) {
            try {
                const topChannelsAndPosts = JSON.parse(message);
                if (topChannelsAndPosts &&
                    topChannelsAndPosts.topPosts &&
                    topChannelsAndPosts.topPosts.length > 0) {
                    topChannelsAndPosts.topPosts.sort((a, b) => a.split(":")[3].localeCompare(b.split(":")[3]));
                    // Function to check posts recursively until we find one with an image
                    const checkPostForImage = (postIndex) => {
                        if (postIndex >= topChannelsAndPosts.topPosts.length) {
                            logger.log(LOGPREFIX +
                                "loadTopFrontPageImage: No posts with images found, using fallback");
                            callbacks.okCallback(undefined);
                            return;
                        }
                        const postKey = topChannelsAndPosts.topPosts[postIndex];
                        const postKeyParts = postKey.split(":");
                        const channelOwnerId = postKeyParts[0];
                        const channelId = postKeyParts[1];
                        //            const postOwnerId = postKeyParts[2];
                        const postId = postKeyParts[3];
                        let url = getContentURL() +
                            "/u/" +
                            channelOwnerId +
                            "/" +
                            channelId +
                            "/" +
                            postId;
                        if (!url.endsWith(".json")) {
                            url = url + ".json";
                        }
                        logger.log(LOGPREFIX +
                            "loadTopFrontPageImage: checking post " +
                            postIndex +
                            ", url = " +
                            url);
                        loadChannelDataFromURL(authUrl(url, cacheBusterStore, auth), {
                            okCallback: (clientDetailCode, data) => {
                                logger.log(LOGPREFIX +
                                    "loadTopFrontPageImage.okCallback: post data = " +
                                    data +
                                    " - " +
                                    clientDetailCode);
                                try {
                                    const dataObj = JSON.parse(data);
                                    logger.log(LOGPREFIX +
                                        "loadTopFrontPageImage: Post Data: " +
                                        JSON.stringify(dataObj));
                                    if (dataObj === null || dataObj === void 0 ? void 0 : dataObj.hasImage) {
                                        let imageUrl;
                                        if (!(dataObj === null || dataObj === void 0 ? void 0 : dataObj.hasMultipleFiles)) {
                                            imageUrl = url.replace(".json", "_512.jpg");
                                        }
                                        else {
                                            imageUrl = url.replace(".json", "_" + (dataObj === null || dataObj === void 0 ? void 0 : dataObj.multipleFileCount) + "_512.jpg");
                                        }
                                        logger.log(LOGPREFIX +
                                            "loadTopFrontPageImage: Found image at post " +
                                            postIndex +
                                            ", imageUrl = " +
                                            imageUrl);
                                        callbacks.okCallback(imageUrl);
                                    }
                                    else {
                                        logger.log(LOGPREFIX +
                                            "loadTopFrontPageImage: Post " +
                                            postIndex +
                                            " has no image, checking next post");
                                        // This post has no image, check the next one
                                        checkPostForImage(postIndex + 1);
                                    }
                                }
                                catch (err) {
                                    logger.error(LOGPREFIX +
                                        "loadTopFrontPageImage: post data parse error: " +
                                        err);
                                    // Error parsing this post, try the next one
                                    checkPostForImage(postIndex + 1);
                                }
                            },
                            errorCallback: (clientDetailCode, errorMessage) => {
                                logger.error(LOGPREFIX +
                                    "loadTopFrontPageImage: post data error: " +
                                    errorMessage +
                                    " (" +
                                    clientDetailCode +
                                    "), trying next post");
                                // Error loading this post, try the next one
                                checkPostForImage(postIndex + 1);
                            },
                        }, cacheBusterStore, logger);
                    };
                    // Start checking from the first post
                    checkPostForImage(0);
                }
            }
            catch (err) {
                logger.error(LOGPREFIX + "loadTopFrontPageImage: error = " + err);
                callbacks.errorCallback(err.message);
                return;
            }
        }
        else {
            const errorMessage = message
                ? message
                : "Request Failed - Status = " + status;
            callbacks.errorCallback(errorMessage);
        }
    };
    const url = getContentURL() +
        PUBLIC_HOME_DISCOVERY_FILENAME +
        cacheBusterStore.getCacheBuster();
    sendGETRequest(apiCallback, url, cacheBusterStore, logger);
};
export const loadLatestPersonalized = (callbacks, navigate, cacheBusterStore, logger, auth, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
deDupeMap) => {
    if (!auth || !auth.sequence) {
        throw new Error("Missing sequence number in auth - " + JSON.stringify(auth));
    }
    const payload = {
        operation: "getLatestPersonalized",
        sequence: auth.sequence,
    };
    const apiCallback = (ok, status, message, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    cacheBusterStore) => {
        var _a;
        logger.log(LOGPREFIX +
            "loadLatestPersonalized: ok = " +
            ok +
            ", status = " +
            status +
            ", message = " +
            message);
        if (!ok || status < 200 || status > 299) {
            logger.error(LOGPREFIX + "status = " + status + ", message = " + message);
            const errorMessage = message
                ? message
                : "Request Failed - Status = " + status;
            callbacks.errorCallback(errorMessage);
            return;
        }
        let response;
        try {
            response = JSON.parse(message);
        }
        catch (err) {
            logger.error(LOGPREFIX + "loadLatestPersonalized: error = " + err);
            callbacks.errorCallback(err.message);
            return;
        }
        if (auth && auth.isSignedIn()) {
            if (response.sequence && response.bearer) {
                auth.setBearerAndSequence(response.bearer, Number(response.sequence), logger);
            }
        }
        const entries = [];
        (_a = response === null || response === void 0 ? void 0 : response.postIds) === null || _a === void 0 ? void 0 : _a.forEach((entry) => {
            const parts = entry.split("/");
            const channelOwnerId = parts[1];
            const channelId = parts[2];
            const postId = parts[3];
            if (deDupeMap[postId]) {
                return;
            }
            deDupeMap[postId] = 1;
            entries.push({
                channelOwnerId,
                channelId,
                postId,
            });
        });
        callbacks.okCallback(entries);
        return;
    };
    sendAjaxRequest(apiCallback, "discovery", payload, auth.bearer, cacheBusterStore, logger);
};
